WiseMetering.Collection.SitePackages = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.SitePackage,
    url: '/site_packages'
});
